import React, { Component } from 'react';
import { connect } from 'react-redux';
import Autocomplete from 'react-autocomplete';
import Modal from '../../../components/Modal';
import { fetchColaboradores, clearColaboradores, saveGenerarCorreoAutorizaciones } from '../../../actions';

const menuStyle = {
  position: 'absolute',
  left: '0',
  top: '100%',
  maxHeight: '350px',
  overflow: 'auto',
  border: '1px solid #cccccc',
};

const inputProps = {
  className: 'form-control awesomplete pillSelct-input',
  name: 'colaborador',
};

const VACIO = '';

class EnviarNotificacion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comentarioNotificacion: '',
      colaborador: '',
      colaboradores: []
    };
  }

  onChangeValue = e => this.setState({ [e.target.name]: e.target.value })

  changeColaborador = (e) => {
    this.onChangeValue(e);
    if (e.target.value.length >= 2) {
      this.props.fetchColaboradores(e.target.value);
    } else if (e.target.value.length === 0) {
      this.props.clearColaboradores();
    }
  }

  selectColaborador = (key) => {
    const { colaboradores } = this.state;
    const colaboradorSelected = colaboradores.filter(colaborador => colaborador.id === key).length;

    if (!colaboradorSelected) {
      const nombres = this.props.colaboradores
      .filter(({ idUsuario }) => idUsuario.toString() === key)[0].nombre;

      const apellidos = this.props.colaboradores
      .filter(({ idUsuario }) => idUsuario.toString() === key)[0].apellidos;
      const colaborador = { id: key, nombres: `${apellidos} ${nombres}` };

      this.setState({ colaborador: '', colaboradores: [...this.state.colaboradores, colaborador] });
      this.props.clearColaboradores();
    }
  }

  removeColaborador = (id) => {
    const { colaboradores } = this.state;
    this.setState({ colaboradores: colaboradores.filter(colaborador => id !== colaborador.id) });
  }

  generarCorreo = (excepcion) => {
    const { colaboradores } = this.state;
    let colaboradoresSelected = colaboradores.map((colaborador) => colaborador.id).toString();
    this.props.saveGenerarCorreoAutorizaciones(
      excepcion.codSolicitud,
      excepcion.numFichaVtaVeh,
      excepcion.numProfVeh,
      excepcion.codEstadoAut,
      colaboradoresSelected,//destinatarios
      VACIO,
      VACIO).then((result) => {
        const response = result.payload.data;
        this.props.openAlert(response);
        this.props.closeModal();
    });
  }

  render() {
    const { excepcion } = this.props;

    return (
      <Modal title='Enviar notificación' idModal='enviar-notificacion' isOpen closeModal={this.props.closeModal} modalSize='modal-dialog'>
        <div className='row'>
          <div className='col-xs-8'>
            <h4 className='bold'>{excepcion.nomCliente}</h4>
          </div>
          <div className='col-xs-4'>
            <p className='labelInfo'>Ficha de venta</p>
            <p className='lead'>{excepcion.numFichaVtaVeh}</p>
          </div>
        </div>
        <div className='row mt-3'>
          <div className='col-xs-6'>
            <p className='labelInfo'>Tipo de solicitud</p>
            <p>{excepcion.desTipoAutExcepcional}</p>
          </div>
          <div className='col-xs-6'>
            <p className='labelInfo'>F° Est. de Regul.</p>
            <p>{excepcion.fecEstimadaRegul}</p>
          </div>
          {
            !excepcion.numPedidosVeh &&
              <div className='col-xs-6'>
                <p className='labelInfo'>Cant. Unidades</p>
                <p>{excepcion.canVehiculos}</p>
              </div>
          }
          <div className='col-xs-6'>
            <p className='labelInfo'>Resp.de la regularización</p>
            <p>{excepcion.codUsuarioRegul}</p>
          </div>
          <div className='col-xs-12'>
            <p className='labelInfo'>Observaciones</p>
            <p>{excepcion.obsSolicitud}</p>
          </div>
        </div>
        {
          excepcion.numPedidosVeh &&
            <div className="row">
              <div className="col-xs-12">
                <p className="labelInfo">N° de Pedidos</p>
                <p>{excepcion.numPedidosVeh}</p>
              </div>
            </div>
        }
        <hr className='dark' />
        <div className='newAut-notify'>
          <p className='labelInfo'>Notificar a:</p>
          <div className='newAut-notify-contacts'>
            {
              this.state.colaboradores.map(colaborador => (
                <label className='pill pill-cyan pillSelct-pills-item' htmlFor='colaborador'>
                  {colaborador.nombres}
                  <button
                    className='pillSelct-delete'
                    onClick={() => this.removeColaborador(colaborador.id)}
                  ><i className='icon ion-close pill-close' />
                  </button>
                </label>
              ))
            }
          </div>
          <div className='newAut-notify-field pillSelct-pills'>
          <Autocomplete
            getItemValue={item => item.idUsuario.toString()}
            value={this.state.colaborador}
            items={this.props.colaboradores}
            renderItem={(item, isHighlighted) =>
              <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                {`${item.apellidos} ${item.nombre}`}
              </div>
            }
            onChange={this.changeColaborador}
            menuStyle={menuStyle}
            inputProps={inputProps}
            wrapperStyle={{ display: 'block', position: 'relative' }}
            onSelect={this.selectColaborador}
          />
          </div>
        </div>
        <div className='modal-actions'>
          <button className='btn btn-default' onClick={this.props.closeModal}>Cancelar</button>
          <button className='btn btn-primary pull-right'
          onClick = {() => this.generarCorreo(excepcion)}>Enviar</button>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    colaboradores: state.colaboradores,
  };
}

export default connect(mapStateToProps,
  { fetchColaboradores,
    clearColaboradores,
    saveGenerarCorreoAutorizaciones
  })(EnviarNotificacion);



// WEBPACK FOOTER //
// ./src/pages/modals/SolicitudExcepcional/EnviarNotificacion.js